/**
 * useExternalConversationUrlTemplate — shared hook returning the tenant's
 * `feature.conversation-external-url-template` setting.
 *
 * Used by Venus and Neptune consumers of `MessageReferences` so message
 * references render as plain `<a href>` anchors instead of triggering
 * the in-app conversation dialog when the tenant has wired up an external
 * CRM URL template.
 *
 * On query failure (e.g. user lacks permission, network error) `data` is
 * undefined and the hook returns `null`, which makes consumers fall back
 * to the in-app conversation dialog. That is the safe default.
 */

import { useQuery } from "@apollo/client/react";
import { gql } from "@apollo/client";

const GET_EXTERNAL_CONVERSATION_URL_TEMPLATE = gql`
    query GetExternalConversationUrlTemplate {
        adminGetEffectiveSetting(key: "feature.conversation-external-url-template")
    }
`;

interface QueryData {
    adminGetEffectiveSetting: string | null;
}

export function useExternalConversationUrlTemplate(): string | null {
    const { data } = useQuery<QueryData>(GET_EXTERNAL_CONVERSATION_URL_TEMPLATE);
    return data?.adminGetEffectiveSetting ?? null;
}
